const state = {
    // 收货地址
    address: null,
    // 收货列表
    addressList: [],
    // 购物车数据
    cartList: [],
    // 是否更新用户订单列表
    isUpdateUserOrder: false,
    // 是否手动选择了地址
    isSelectAddress: false,
    // 用户订单数量
    orderCount: 0,
    orderId: null
}
export default state